import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ChannelCard from "../components/Cards/ChannelCard";
import useHttp from "../hooks/use-http";
import Videos from "../components/Videos";

const ChannelDetailPage = () => {
  const { sendRequest, loading, error } = useHttp();

  const [channelDetail, setChannelDetail] = useState(null);
  const [videos, setVideos] = useState([]);

  const param = useParams();
  const id = param.id;

  useEffect(() => {
    const fetchChannel = async () => {
      const data = await sendRequest(`channels?part=snippet&id=${id}`);
      setChannelDetail(data.items[0]);
    };

    const fetchVideos = async () => {
      const data = await sendRequest(
        `search?channelId=${id}&part=snippet%2Cid&order=date`
      );

      setVideos(data.items);
    };

    fetchChannel();
    fetchVideos();
  }, [id]);

  return (
    <Box minHeight="95vh">
      <Box>
        <div
          style={{
            height: "300px",
            background:
              "linear-gradient(90deg, rgba(0,238,247,1) 0%, rgba(206,3,184,1) 100%, rgba(0,212,255,1) 100%)",
            zIndex: 10,
          }}
        />
        {channelDetail && (
          <ChannelCard
            id={channelDetail.id}
            snippet={channelDetail.snippet}
            statistics={channelDetail.statistics}
            marginTop="-93px"
          />
        )}
      </Box>
      <Box p={2} display="flex">
        <Box sx={{ mr: { sm: "100px" } }} />
        <Videos videos={videos} />
      </Box>
    </Box>
  );
};

export default ChannelDetailPage;
